import React from 'react';

const AppButton = ({
  children,
  variant = 'primary',
  size = 'md',
  className = '',
  type = 'button',
  ...props
}) => (
  <button
    type={type}
    className={`app-button app-button-${variant} app-button-size-${size} ${className}`.trim()}
    {...props}
  >
    {children}
  </button>
);

export default AppButton;
